export default {
  '报图完成': 'Report drawings finshed',
  '展位号': 'Booth',
  '面积': 'Area',
  '报图已完成，等待主场审图人员审核': 'The drawings has been reported, waiting for the review of the home staff',
  '审核结果将会以邮件的形式发送到您的邮箱，请注意查收': 'The audit result will be sent to your email address. Please check it',
  '如有疑问，请前往首页咨询相关负责人': 'If in doubt, please consult the relevant person in charge',
  '去缴费': 'To pay fee',
  '结束报图': 'End'
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingEnd.js